import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import {Logo, IconHelp, IconRight, IconTwitter} from '../../../assets/icons/svgIcon';
import { SvgAssets } from '../../../assets/icons/iconSvg';
import c from '../../../constants/Colors';
import { getTyC } from '../../../store/sagas/authApi';
import { notificacion } from '../../../utilitarios/util';

export class Footer extends Component {
  static displayName = Footer.name;

  constructor (props) {
    super(props);

    this.state = {
      
    };
  }

  loadInBrowser = () => {
    window.open(this.state.tyc);
  };

  postTyC = async () => {
    getTyC()
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false, tyc: result.dto.urlTyC })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });

  }

  componentDidMount(){
    this.postTyC();
  }

  render () {
    const { isLoggedIn } = this.props;
    return (
      <footer>
        { isLoggedIn ?
          <Container className="list-footer">
            {/* <Logo className='logo' /> */}
            <img className='logo' src={require('../../../assets/img/logo-1.png')} />
            <div className="options">
              <h6><IconHelp className='svg'/>Ayuda</h6>
              <ul>
                <li><Link to="/preguntas-frecuentes">Preguntas frecuentes<SvgAssets icon="icon-right" fill={c.azulClaro} /></Link></li>
                <li><Link to="/sugerencias" className="red">Sugerencias<SvgAssets icon="icon-right" fill={c.rojoClaro} /></Link></li>
                {/* <li><Link to="/requerimientos">Requerimientos<SvgAssets icon="icon-right" fill={c.azulClaro} /></Link></li> */}
              </ul>
            </div>
            {/* <div className="rrss">
              <h6>Redes Sociales</h6>
              <a href="#"><IconTwitter className='icon' /></a>
              <a href="#"><IconTwitter className='icon' /></a>
              <a href="#"><IconTwitter className='icon' /></a>
              <a href="#"><IconTwitter className='icon' /></a>
            </div> */}
          </Container>
          : null
        }
        <div className="sub-footer">
          <Container>
            <span>© 2020 Asiri Crosland | Copyright, Lima - Perú | <a href="#" onClick={(e) => {e.preventDefault(); this.loadInBrowser()}}>Términos y condiciones</a></span>
          </Container>
        </div>
      </footer>
    );
  }
}
